import {getDocsBaseUrl} from '../config';

const baseUrl = getDocsBaseUrl() || '';

export const docsUrls = {
    'acl:permissions': `${baseUrl}/user-guide/storage/access-control#authorization`,
    'acl:row-level-security': `${baseUrl}/user-guide/storage/row-level-security`,
    'api:cli': `${baseUrl}/api/cli/cli`,
    'api:commands#patch_operation_spec': `${baseUrl}/api/commands#patch_operation_spec`,
    'bundle-controller:reserved-memory': ``,
    'bundles:tablet-errors': `${baseUrl}/faq#dynamic_tables`,
    'chyt:yt_tables#dynamic': `${baseUrl}/user-guide/data-processing/chyt/yt-tables#dynamic`,
    'common:quota_request': '',
    'common:quotas#request_quota': '',
    'common:regular_system_processes': '',
    'cypress:links': `${baseUrl}/user-guide/storage/links`,
    'cypress:ttl': `${baseUrl}/user-guide/storage/cypress#TTL`,
    'dynamic-tables:concepts#tablet_cell_bundles': `${baseUrl}/user-guide/dynamic-tables/concepts#tablet_cell_bundles`,
    'dynamic-tables:cross-dc': `${baseUrl}/user-guide/dynamic-tables/dynamic-tables-resources#georaspredelyonnye-klastery-cross-dc`,
    'dynamic-tables:overview#in_memory': `${baseUrl}/user-guide/dynamic-tables/overview#in_memory`,
    'dynamic-tables:overview': `${baseUrl}/user-guide/dynamic-tables/overview`,
    'dynamic-tables:queues#creating-a-consumer': `${baseUrl}/user-guide/dynamic-tables/queues#creating-a-consumer`,
    'dynamic-tables:sorted_dynamic_tables#aggr_columns': `${baseUrl}/user-guide/dynamic-tables/sorted-dynamic-tables#aggr_columns`,
    'dynamic-tables:transactions#conflicts': `${baseUrl}/user-guide/dynamic-tables/transactions#conflicts`,
    'faq:enablepathautocorrection': `${baseUrl}/faq#enablepathautocorrection`,
    'faq:web_interface_table_download': `${baseUrl}/faq#web_interface_table_download`,
    'flow:update_static_spec:force': '',
    'operations:erase': `${baseUrl}/user-guide/data-processing/operations/erase`,
    'operations:merge': `${baseUrl}/user-guide/data-processing/operations/merge`,
    'operations:operations_options#obshie-opcii-dlya-vseh-tipov-operacij': `${baseUrl}/user-guide/data-processing/operations/operations-options#common_options`,
    'operations:operations_options': `${baseUrl}/user-guide/data-processing/operations/operations-options`,
    'operations:overview#aborted_jobs': `${baseUrl}/user-guide/data-processing/operations/overview#aborted_jobs`,
    'operations:overview#completed_jobs': `${baseUrl}/user-guide/data-processing/operations/overview#completed_jobs`,
    'operations:recommendations#slishkom-melkie-chanki': `${baseUrl}/user-guide/data-processing/operations/recommendations#slishkom-melkie-chanki`,
    'operations:remote_copy': `${baseUrl}/user-guide/data-processing/operations/remote-copy`,
    'overview:quickstart': `${baseUrl}/overview/try-yt`,
    'problems:jobstatistics': `${baseUrl}/user-guide/problems/jobstatistics`,
    'scheduler:integral_guarantees': `${baseUrl}/user-guide/data-processing/scheduler/integral-guarantees`,
    'scheduler:scheduler_and_pools': `${baseUrl}/user-guide/data-processing/scheduler/scheduler-and-pools`,
    'storage:accounts': `${baseUrl}/user-guide/storage/accounts`,
    'storage:chunks#optimize_for': `${baseUrl}/user-guide/storage/chunks#optimize_for`,
    'storage:compression#compression_codecs': `${baseUrl}/user-guide/storage/compression#compression_codecs`,
    'storage:compression': `${baseUrl}/user-guide/storage/compression`,
    'storage:data_types#schema': `${baseUrl}/user-guide/storage/data-types#schema`,
    'storage:data_types#schema_optional': `${baseUrl}/user-guide/storage/data-types#schema_optional`,
    'storage:excel#skachivanie': `${baseUrl}/user-guide/excel#skachivanie`,
    'storage:excel': `${baseUrl}/user-guide/excel`,
    'storage:formats': `${baseUrl}/user-guide/storage/formats`,
    'storage:media#primary': `${baseUrl}/user-guide/storage/media#primary`,
    'storage:replication#erasure': `${baseUrl}/user-guide/storage/replication#erasure`,
    'storage:replication#replication': `${baseUrl}/user-guide/storage/replication#replication`,
    'storage:static_schema#overview': `${baseUrl}/user-guide/storage/static-schema`,
    'storage:static_schema': `${baseUrl}/user-guide/storage/static-schema`,
    'storage:static_tables': `${baseUrl}/user-guide/storage/static-tables`,
    faq: `${baseUrl}/faq`,
};

export type DocsUrls = typeof docsUrls;
